import React from 'react'
import cx from 'classnames'

import './style.scss'

export default function CellStyleWrapper({ children, isNotActive, isCentered, isJustifiedToCenter, innerClass }) {
    return (
        <div
            className={cx(
                'cell-style-wrapper',
                { inactive: isNotActive, 'centered-cell': isCentered, 'justify-center': isJustifiedToCenter },
                innerClass
            )}
        >
            {children}
        </div>
    )
}
